module.exports = __webpack_public_path__ + "media/packs/landing_page/images/Facebook-eb5730e073395063b2fa50101b5dbc36.png";